import {handleFetchError, HtmlDialog, showNotice} from "../helpers/functions.js";
import JSX from "../helpers/react.js";
import ClearFav from "../models/import-fav/ClearFav.js";

interface JsonProgress{
    progress: number;
    error?: string;
}
interface ExportData {
    dataType: 'json'|'html'|'0';
    needMyVote: 1|0;
    get valid(): boolean;
}
function download(filename: string, text: string) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
class ImportExportFavorites {
    private readonly $dialog: JQuery;
    private readonly exportData: ExportData = {
        dataType: 'json',
        needMyVote: 1,
        get valid(){
            return this.dataType!=='0';
        }
    };
    private count: number;
    private readonly $progressBarImport: JQuery<HTMLDivElement>;
    constructor() {
        this.count = Array.from<HTMLSpanElement>($('.tabs-li.li-profile.countable .count'))
            .reduce((c, j)=> ({c: c.c+(+j.innerText)}), {c: 0}).c;
        this.$dialog = $(
<HtmlDialog>
    <div className="top-data" style="margin: 10px 5px 0 5px">
        <div className="fa fa-times-circle top-icon-close-dialog cancel-button" style={{margin: "5px"}}></div>
        <h1>Импорт/экспорт списков (всего&nbsp;{this.count})</h1>
        <div className="content" style="display:block;">
            <div className="tabs-block">
                <div className="tabs-header">
                    <ul className="tabs">
                        <li data-id="#import-fav" className="tabs-li active materiable"><i className="fa fa-cloud-download" /> Импорт</li>
                        <li data-id="#export-fav" className="tabs-li materiable"><i className="fa fa-cloud-upload" /> Экспорт</li>
                        <li data-id="#clear-fav" className="tabs-li materiable"><i className="fa fa-trash" /> Очистка</li>
                    </ul>
                </div>
                <div className="tabs-content">
                    <div id="import-fav" className="tab-content active">
                        <input hidden type="file" accept=".json,.html,.csv,application/json,text/html,text/csv" id="select-import-fav" onInput={this.importFileSelected}/>
                        <br />
                        <h4>Если у Вас есть списки на других сайтах, то тут можно их импортировать.</h4>
                        <br />
                        <p>К сожалению, названия <b>аниме</b> часто различаются, поэтому скрипт может не найти некоторые тайтлы (или найти некорректно). Пожалуйста, имейте это в виду!</p>
                        <br />
                        <div className="accordion">
                            <div>
                                <div className="accordion-item">Поддерживаемые форматы</div>
                                <div className="accordion-content">
                                    На данный момент поддерживаются следующие форматы:
                                    <ol>
                                        <li><b>JSON</b> формат － из <a href="//shikimori.one" target="_blank">shikimori.one</a></li>
                                        <li><b>HTML</b> формат － со старого сайта (или если Вы ранее экспортировали списки)</li>
                                        <li><b>CSV</b> формат － из мобильного приложения <a href="//anixart.tv" target="_blank">Anixart</a></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <p style="text-align: center"><button className="main-button select-file-btn bordered" style="margin:5px" onClick={()=>this.$dialog.find('#select-import-fav').trigger('click')}>Выбрать файл</button></p>
                        <div className="stats-container" style="width: 100%">
                            <div className="progress-bar" style="height: 40px">
                                <div className="progress-bar-column" style="background: var(--main-red); width:0;padding: 0" />
                                <div className="progress-status" />
                            </div>
                        </div>
                    </div>
                    <div id="export-fav" className="tab-content">
                        <br />
                        <h4>Тут можно экспортировать списки, чтобы больше никогда их не потерять.</h4>
                        <br />
                        <div>
                            <span>Формат экспортируемых данных: </span>
                            <select className="slim-select" id="export-datatype" style="max-width: 200px; margin-bottom: 5px;">
                                <option value="0" selected>Не выбрано</option>
                                <option value="json" data-description="JSON формат совместим с сайтом <a href='//shikimori.one' target='_blank'>shikimori.one</a> (можно импортировать списки на <a href='//shikimori.one' target='_blank'>сайте</a> и в мобильном приложении <a href='//anixart.tv' target='_blank'>Anixart</a>)">JSON</option>
                                <option value="html" data-description="HTML файл с данными об аниме. Можно потом импортировать обратно на сайт.">HTML</option>
                            </select>
                        </div>
                        <p id="format-data" style="margin-left: 30px"></p>
                        <div>
                            <span>Моя оценка: </span>
                            <select className="slim-select" id="export-need-vote" style="max-width: 200px">
                                <option value="1" selected>Включить</option>
                                <option value="0">Исключить</option>
                            </select>
                        </div>
                        <p></p>
                        <div style="text-align: center">
                            <button className="main-button export-button bordered blocked" style="margin: 15px">Экспортировать</button>
                        </div>
                    </div>
                    <ClearFav />
                </div>
            </div>
        </div>
    </div>
</HtmlDialog>
        )
            //export
            .on('change', '#export-datatype', ()=>{
                const elementSelected=
                    this.$dialog.find('#export-datatype').find<HTMLOptionElement>(':selected');
                this.$dialog.find('#format-data').html(elementSelected.data('description'));
                this.exportData.dataType = this.$dialog.find('#export-datatype').val() as ('json'|'html'|'0');
                this.lockExportButton();
            })
            .on('change', '#export-need-vote', ()=>{
                this.exportData.needMyVote = this.$dialog.find('#export-need-vote').val() as 0|1;
            })
            .on('click', '.export-button', this.doExportData.bind(this))
        this.$progressBarImport = this.$dialog.find('.progress-bar') as JQuery<HTMLDivElement>;
        // @ts-ignore
        this.$dialog.find('.slim-select').slimSelect();
    }
    private async doExportData(){

        const $this =this.$dialog.find('.export-button');
        if($this.hasClass('blocked')) return;
        $this.addClass('blocked');
        try {
            const data = await fetch("/actions/export-favorites.php?" + new URLSearchParams({
                format: this.exportData.dataType,
                vote: this.exportData.needMyVote + ''
            })).then(e=>e.json()) as {filename: string; data: string};
            download(data.filename, data.data);
        }catch (e){
            handleFetchError(e);
        }finally {
            $this.removeClass('blocked');
        }
    }
    private lockExportButton(){
        const btn = this.$dialog.find('.export-button');
        if(this.exportData.valid) btn.removeClass('blocked');
        else btn.addClass('blocked');
    }
    private  importFileSelected = async () =>{
        const el: JQuery<HTMLInputElement> = this.$dialog.find('#select-import-fav') as JQuery<HTMLInputElement>;
        const file: File|undefined = el[0]?.files?.[0]
        if(!file) return;
        let text: string
        try{ text= await file?.text(); }
        catch (e){
            const reader = new FileReader();
            text = await new Promise<string>((resolve, reject)=>{
                reader.onload = ()=> resolve(reader.result as string);
                reader.onerror = ()=> reject(reader.error);
                reader.readAsText(file);
            });
        }
        if(new Blob([text]).size > (2<<23)) return showNotice('Файл слишком большой - максимум 16МБ');
        this.uploadFavorites(text);
    }
    private set loadingProgress(progress: number){
        if(progress === 1){
            showNotice('Списки успешно импортированы!\nПерезагрузите страницу, чтобы изменения отобразились','Ура!', );
            setTimeout(this.destroy.bind(this), 3000);
        }
        progress *= 100;
        this.$progressBarImport.find('.progress-bar-column').css('width', progress+'%');
        this.$progressBarImport.find('.progress-status').text(Math.round(progress) + '%')
    }

    destroy(){
        this.$dialog.remove();
    }
    show(){
        this.$dialog.appendTo('body');
    }
    private onImportProgress(xhr: XMLHttpRequest){
        const text = xhr.responseText.split('\n');
        const lastText: string|undefined = text[text.length-2];
        if(!lastText) return;
        let jsonProgress: JsonProgress = JSON.parse(lastText) as JsonProgress;
        if(jsonProgress.error) {
            this.loadingProgress = 0;
            return showNotice(jsonProgress.error, 'Ошибка', 'error');
        }
        else {
            this.loadingProgress = jsonProgress.progress * .9 + .1;
        }
    }
    private uploadFavorites(text: string) {
        const xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", (evt) => {
            if (evt.lengthComputable) {
                const percentComplete = evt.loaded / evt.total;
                this.loadingProgress = percentComplete/10;
            }
        }, false);
        xhr.onprogress = this.onImportProgress.bind(this, xhr);
        xhr.open('POST', '/actions/save-favorites.php');
        // xhr.setRequestHeader('content-type', 'application/json')
        const formData = new FormData();
        const blob = new Blob([text], {type : 'text/plain'})
        formData.append('text', blob, 'file.txt')

        xhr.send(formData);
    }
    static showWindow(){
        new ImportExportFavorites().show();
    }
}
export {ImportExportFavorites};